export type AlertTheme = 'Politique' | 'Économie' | 'Santé' | 'Éducation' | 'Environnement' | 'Infrastructure';
export type AlertSourceType = 'Institution' | 'Parlement' | 'Parti' | 'Région' | 'Interaction';

export type AlertStatus = 'brouillon' | 'publie' | 'programme';

export interface CitizenAlert {
  id: string;
  title: Record<string, string>;
  description: Record<string, string>;
  date: string;
  sourceName: string;
  sourceType: AlertSourceType;
  region: string; // 'Toutes' ou nom de la région (ex: 'Casablanca-Settat')
  theme: AlertTheme;
  isImportant: boolean;
  linkUrl?: string;
  imageUrl?: string;
  status?: AlertStatus;
  isActive?: boolean;
  scheduledFor?: string;
  targetUserId?: string; // Si présent, seule cette personne voit l'alerte
  notificationType?: 'global' | 'reminder_event' | 'reminder_emission' | 'talk_reply' | 'ring_approved' | 'system';
}

export const citizenAlertsData: CitizenAlert[] = [
  {
    id: "al-1",
    title: { fr: "Validation du projet de loi de finances", ar: "المصادقة على مشروع قانون المالية", zgh: "ⴰⵣⵔⴼ ⵏ ⵜⵥⵕⴼⵜ" },
    description: { fr: "Le Parlement a validé à la majorité absolue le nouveau projet de loi de finances pour l'année prochaine.", ar: "صادق البرلمان بالأغلبية المطلقة على مشروع قانون المالية الجديد للعام المقبل.", zgh: "ⵉⵙⵙⵖⵥⵏ ⵓⴱⵕⵍⴰⵎⴰⵏ ⵙ ⵜⵓⴳⵜ ⵅⴼ ⵓⵙⵏⴼⴰⵔ ⵏ ⵓⵣⵔⴼ ⵏ ⵜⵥⵕⴼⵜ." },
    date: "2026-04-01",
    sourceName: "Parlement",
    sourceType: "Parlement",
    region: "Toutes",
    theme: "Économie",
    isImportant: true,
    status: 'publie',
    isActive: true
  },
  {
    id: "al-2",
    title: { fr: "Nouveau CHU à Agadir", ar: "مستشفى جامعي جديد بأكادير", zgh: "ⴰⵙⴳⵏⴰⴼ ⴰⵎⴰⵙⴷⴰⵡ ⴰⵎⴰⵢⵏⵓ ⴳ ⴰⴳⴰⴷⵉⵔ" },
    description: { fr: "Inauguration du nouveau Centre Hospitalier Universitaire au profit de la région Souss-Massa.", ar: "افتتاح المركز الاستشفائي الجامعي الجديد لجهة سوس ماسة.", zgh: "ⴰⵕⵥⵥⵓⵎ ⵏ ⵓⵙⴳⵏⴰⴼ ⴰⵎⴰⵙⴷⴰⵡ ⵉ ⵜⵎⵏⴰⴹⵜ ⵏ ⵙⵓⵙ ⵎⴰⵙⵙⴰ." },
    date: "2026-03-28",
    sourceName: "Conseil Régional Souss-Massa",
    sourceType: "Région",
    region: "Souss-Massa",
    theme: "Santé",
    isImportant: false,
    imageUrl: "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?auto=format&fit=crop&q=80&w=800",
    status: 'publie',
    isActive: true
  },
  {
    id: "al-3",
    title: { fr: "Renforcement des bourses étudiantes", ar: "تعزيز المنح الطلابية", zgh: "ⵜⵉⴳⵎⵉ ⵏ ⵜⵉⴳⴳⴰ ⵏ ⵉⵎⵃⴹⴰⵕⵏ" },
    description: { fr: "Le Ministère de l'Enseignement Supérieur annonce une hausse de 10% des bourses pour les étudiants boursiers.", ar: "أعلنت وزارة التعليم العالي عن زيادة بنسبة 10٪ في المنح للطلاب.", zgh: "ⵜⵙⵙⵓⵎⵔ ⵜⵎⴰⵡⴰⵙⵜ ⵏ ⵓⵙⵍⵎⴷ ⴰⵏⴰⴼⵍⵍⴰ ⴰⵙⵎⵖⵔ ⵏ 10% ⴳ ⵜⵉⴳⴳⴰ ⵏ ⵉⵎⵃⴹⴰⵕⵏ." },
    date: "2026-03-25",
    sourceName: "Gouvernement",
    sourceType: "Institution",
    region: "Toutes",
    theme: "Éducation",
    isImportant: true,
    status: 'publie',
    isActive: true
  },
  {
    id: "al-4",
    title: { fr: "Lancement du tramway ligne T3", ar: "إطلاق الخط الثالث للترامواي", zgh: "ⴰⵕⵥⵥⵓⵎ ⵏ ⵓⵣⵔⵉⴳ T3 ⵏ ⵟⵕⴰⵎⵡⴰⵢ" },
    description: { fr: "Mise en service de la nouvelle ligne T3 du tramway pour décongestionner le trafic urbain.", ar: "بدء تشغيل الخط الجديد T3 للترامواي لتخفيف الازدحام المروري.", zgh: "ⴰⵙⵡⵓⵔⵉ ⵏ ⵓⵣⵔⵉⴳ ⴰⵎⴰⵢⵏⵓ T3 ⵏ ⵟⵕⴰⵎⵡⴰⵢ ⵉ ⵓⵙⵔⴼⵙ ⵏ ⵓⵎⵓⵙⵙⵓ." },
    date: "2026-03-20",
    sourceName: "Conseil de la Ville",
    sourceType: "Région",
    region: "Casablanca-Settat",
    theme: "Infrastructure",
    isImportant: false,
    status: 'publie',
    isActive: true
  },
  {
    id: "al-5",
    title: { fr: "Réforme du code de l'urbanisme", ar: "إصلاح قانون التعمير", zgh: "ⴰⵙⵏⴼⵍ ⵏ ⵓⵣⵔⴼ ⵏ ⵜⵖⵔⵎⴰⵏⵜ" },
    description: { fr: "Proposition de loi déposée par le RNI pour simplifier les procédures d'obtention de permis de construire.", ar: "مقترح قانون قدمه التجمع الوطني للأحرار لتبسيط إجراءات الحصول على رخص البناء.", zgh: "ⴰⵙⵓⵎⵔ ⵏ ⵓⵣⵔⴼ ⵙⴳ RNI ⵉ ⵓⵙⴼⵙⵙⵢ ⵏ ⵜⴱⵔⵉⴷⵉⵏ ⵏ ⵜⵓⵔⴰⴳⵉⵏ ⵏ ⵜⵓⵚⴽⴰ." },
    date: "2026-03-15",
    sourceName: "Parti RNI",
    sourceType: "Parti",
    region: "Toutes",
    theme: "Politique",
    isImportant: false,
    status: 'publie',
    isActive: true
  },
  {
     id: "al-6",
     title: { fr: "Programme 'Écoles Vertes' L'Oriental", ar: "برنامج 'مدارس خضراء' جهة الشرق", zgh: "ⴰⵖⴰⵡⴰⵙ 'ⵜⵉⵏⵎⴰⵍ ⵜⵉⵣⴳⵣⴰⵡⵉⵏ' ⵏ ⵓⴳⵎⵓⴹ" },
     description: { fr: "Le Conseil Régional lance le financement de l'installation de panneaux solaires dans 150 écoles rurales.", ar: "يطلق المجلس الجهوي تمويل تركيب الألواح الشمسية في 150 مدرسة قروية.", zgh: "ⵉⵙⵙⵏⵜⵉ ⵓⵙⵇⵇⵉⵎ ⵏ ⵜⵎⵏⴰⴹⵜ ⴰⵙⵙⴰⵔⵓ ⵏ ⵜⵉⴼⵉⵍⵉⵜⵉⵏ ⵏ ⵜⴰⴼⵓⴽⵜ ⴳ 150 ⵏ ⵜⵉⵏⵎⴰⵍ ⵜⵉⴼⴰⵔⴰⵏⵉⵏ." },
     date: "2026-04-02",
     sourceName: "Conseil Régional de l'Oriental",
     sourceType: "Région",
     region: "L'Oriental",
     theme: "Environnement",
     isImportant: false,
     imageUrl: "https://images.unsplash.com/photo-1509391366360-1e97fb58bd41?auto=format&fit=crop&q=80&w=800",
     status: 'publie',
     isActive: true
  }
];
